import { Table, TableContainer, Thead, Tr, Th, Tbody, Td, Box, SkeletonText } from "@chakra-ui/react";
import { format } from "date-fns";

import { COLORS, ROLES } from "@/common/constants";
import Pagination from "../Layouts/Pagination";
import { PaginationProps } from "../Layouts/types";

const TABLE_COLUMNS = ["Order Number", "Vessel Name", "IMO Number", "Vessel Type", "Review Date", "ADD/ALD"];
const TABLE_COLUMNS_ADMIN = ["Order Number", "Requestor", "Vessel Name", "IMO Number", "Vessel Type", "Review Date", "ADD/ALD", "2nd Download"];

export type SireDataSimple = {
    id: string,
    sequenceId: string,
    requestor?: string,
    requestorId?: string,
    vesselId: string,
    vesselName: string,
    imoNumber: string,
    vesselType: string,
    reviewDate: Date | string,
    addaldPertamina: string,
    isSecondDownload: boolean,
    created: Date | string,
}

interface TableSireReviewSimpleProps extends PaginationProps {
    dataList: SireDataSimple[],
    isLoading: boolean,
    role: string,
}

const TableSireReviewSimple = ({
    dataList,
    isLoading,
    currentPageSize,
    handleChangePageSize,
    handleChangePageNumber,
    currentPageNumber,
    totalPageNumber,
    hasNextPage,
    role
}: TableSireReviewSimpleProps) => {
    const COLUMNS = (role === ROLES.SUPER_ADMIN || role === ROLES.FINANCE ? TABLE_COLUMNS_ADMIN : TABLE_COLUMNS);
    const NUM_COLUMNS = COLUMNS.length;

    const renderRows = () => {
        if (isLoading) {
            return (
                <Tr>
                    <Td colSpan={NUM_COLUMNS}>
                        <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                    </Td>
                </Tr>
            );
        }

        if (!dataList) {
            return (
                <Tr>
                    <Td colSpan={NUM_COLUMNS} textAlign="center">Data not found</Td>
                </Tr>
            );
        }

        return dataList.map((item) => (
            <Tr key={item.id}>
                <Td>{item.sequenceId || '-'}</Td>
                {(role === ROLES.SUPER_ADMIN || role === ROLES.FINANCE) && <Td>{item.requestor || '-'}</Td>}
                <Td>{item.vesselName || '-'}</Td>
                <Td>{item.imoNumber || '-'}</Td>
                <Td>{item.vesselType || '-'}</Td>
                <Td>{item.reviewDate ? format(new Date(item.reviewDate), 'dd-MM-yyyy') : '-'}</Td>
                <Td>{item.addaldPertamina || '-'}</Td>
                <Td style={{ display: 'flex', justifyContent: 'center' }}>{item.isSecondDownload ? 'Yes' : 'No'}</Td>
            </Tr>
        ));
    }
        
    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            {COLUMNS.map((header) => (
                                <Th key={header} color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign={["Result", "Status", "Action"].includes(header) ? 'center' : 'left'}>
                                    {header}
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {renderRows()}
                    </Tbody>
                </Table>
            </Box>
            <Pagination
                currentPageSize={currentPageSize}
                currentPageNumber={currentPageNumber}
                totalPageNumber={totalPageNumber}
                handleChangePageSize={handleChangePageSize}
                handleChangePageNumber={handleChangePageNumber}
                hasNextPage={hasNextPage}
            />
        </TableContainer>
    );
}

export default TableSireReviewSimple;
